const { externalDocumentationUrl } = require("./external-docs");

// Exact legacy URLs verified against existing published CMS destinations:
// QuickLinksBox12 -> FAQ66/theme3;
// theme3 HelpfulLinks57 -> FAQ65/theme3. No translation is inferred here.
const dutchLegacyHelpPaths = {
  "/help-center/faqs/mojave-theme-nl-be/can-customers-checkout-in-a-different-currency-2": "/help-center/faqs/theme/mojave/can-customers-checkout-in-a-different-currency",
  "/help-center/faqs/mojave/what-does-the-mojave-support-team-cover": "/help-center/faqs/theme/mojave/what-does-the-mojave-support-team-cover",
};

function verifiedCmsHref(href, locale) {
  if (locale !== "nl-be") return href;
  const suffixIndex = href.search(/[?#]/);
  const path = suffixIndex < 0 ? href : href.slice(0, suffixIndex);
  const suffix = suffixIndex < 0 ? "" : href.slice(suffixIndex);
  return dutchLegacyHelpPaths[path] ? `${dutchLegacyHelpPaths[path]}${suffix}` : href;
}

/**
 * Give Next the locale separately from the path so domain routing adds it once.
 * Explicit CMS locale paths keep their intended language. Retired documentation
 * goes to its verified external English destination; other external URLs stay intact.
 * @returns {{ href: string, locale: string | false }}
 */
function localizedLinkProps(href, locale = "en") {
  const documentation = externalDocumentationUrl(href);
  if (documentation) return { href: documentation, locale: false };
  if (!href || /^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(href)) {
    return { href, locale: false };
  }
  const explicitLocale = href.match(/^\/(en|nl-be|tr-tr)(?=\/|[?#]|$)/i);
  if (explicitLocale) {
    const path = href.slice(explicitLocale[0].length);
    return {
      href: verifiedCmsHref(path.startsWith("/") ? path : `/${path}`, explicitLocale[1].toLowerCase()),
      locale: explicitLocale[1].toLowerCase(),
    };
  }
  return { href: verifiedCmsHref(href, locale), locale };
}
function linkRel(nofollow, newTab) {
  return [nofollow && "nofollow", newTab && "noopener", newTab && "noreferrer"].filter(Boolean).join(" ");
}
module.exports = { localizedLinkProps, linkRel };
